import React, { useState } from 'react';
import AppButton from '../../../common/Forms/AppButton/AppButton';
import NewHotelSelector from '../../../common/HotelSelector_new/NewHotelSelector';
import styles from './HotelsEditor.styles';

export default function HotelsEditor({
  currentHotel,
  appearanceData,
  onCopyToHotels,
  label,
  labelSave,
  disabled = false,
  hidden = false,
}) {
  if (hidden) return '';
  const [selectedHotels, setSelectedHotels] = useState([]);

  const handleCopy = () => {
    if (selectedHotels.length > 0) {
      onCopyToHotels({
        hotels: selectedHotels,
        appearanceData,
      });
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.title}>
        <b>{label}</b>
      </div>
      <div style={styles.hotelSelectorContainer}>
        <NewHotelSelector
          enableAllHotels={false}
          mode="multiple"
          onHotelSelected={setSelectedHotels}
          autoSelect={true}
          excludeHotels={[currentHotel?.key]}
          disabled={disabled}
        />
      </div>
      <AppButton
        text={labelSave}
        action={() => handleCopy()}
        small
        style={styles.buttonStyle}
        disabled={selectedHotels === 0 || disabled}
      />
    </div>
  );
}
